module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "div-confirmation"
  }, [_c('header-component'), _vm._v(" "), _c('div', {
    staticClass: "container-fluid g-py-100"
  }, [(!_vm.isDataLoading) ? _c('div', {
    staticClass: "order-confirmation row"
  }, [(_vm.isOrderValid) ? _c('div', {
    staticClass: "col-lg-8 offset-lg-2"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.$route.params.isSummaryOnly == '1' && _vm.Order.orderStatus != 'Error') ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('h2', {}, [_vm._v("Congratulations!")]), _vm._v(" "), _c('p', {
    staticClass: "order-confimation-description"
  }, [_vm._v("Your order has been submitted successfully.")]), _vm._v(" "), _c('p', {
    staticClass: "order-confimation-description"
  }, [_vm._v("\n                            Please print a copy of this for your records and include a copy along with your frame if you have placed a frame-to-come order.\n                        ")])]) : (_vm.Order.orderStatus == 'Error') ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('p', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Error!")]), _vm._v(" "), _c('p', {
    staticClass: "order-confimation-description"
  }, [_vm._v("This order has an error.")]), _vm._v(" "), _c('p', {
    staticClass: "order-confimation-description"
  }, [_vm._v("\n                            Kindly contact the OneSight EssilorLuxottica Foundation team for more information\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.isCoveredPaymentShown) ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('p', {
    staticStyle: {
      "color": "green",
      "font-weight": "bold"
    }
  }, [_vm._v("The voucher provided covers the payment amount for this order")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row mx-auto"
  }, [(_vm.Order.orderStatus.toLowerCase() == 'shipped') ? _c('div', {
    staticClass: "ml-3 mr-3"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-my-10",
    on: {
      "click": function($event) {
        return _vm.MarkAsDispensed(_vm.Order.id)
      }
    }
  }, [_vm._v("Mark as Dispensed")])]) : _vm._e(), _vm._v(" "), (_vm.Order.orderStatus.toLowerCase() == 'dispensed') ? _c('div', {
    staticClass: "ml-3 mr-3"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-my-10",
    on: {
      "click": function($event) {
        return _vm.RevertDispensed(_vm.Order.id)
      }
    }
  }, [_vm._v("Not Dispensed")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ml-3 mr-3"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-my-10",
    on: {
      "click": function($event) {
        return _vm.GenerateHtml()
      }
    }
  }, [_vm._v("Print Order Summary")])]), _vm._v(" "), (_vm.Order.orderStatus != 'Error') ? _c('div', {
    staticClass: "ml-3 mr-3"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-my-10",
    on: {
      "click": function($event) {
        return _vm.ReuseOrder(_vm.Order.id)
      }
    }
  }, [_vm._v("Remake/Redo Order")])]) : _vm._e(), _vm._v(" "), (_vm.Order.orderStatus != 'Error') ? _c('div', {
    staticClass: "ml-3 mr-3"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-my-10",
    on: {
      "click": function($event) {
        return _vm.ExtraPair(_vm.Order.id)
      }
    }
  }, [_vm._v("Order Extra Pair")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ml-3 mr-3"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-my-10 btnDisabled",
    attrs: {
      "disabled": _vm.isCancelled,
      "data-balloon": _vm.GetTooltip(_vm.isCancelled),
      "data-balloon-pos": "up"
    },
    on: {
      "click": function($event) {
        return _vm.ToggleJotForm()
      }
    }
  }, [_vm._v("Request Cancellation")])]), _vm._v(" "), _c('div', {
    staticClass: "ml-3 mr-3"
  }, [(_vm.$route.params.isSummaryOnly == '1') ? _c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-my-10",
    on: {
      "click": function($event) {
        return _vm.NewOrder()
      }
    }
  }, [_vm._v("Place New Order")]) : _vm._e()])])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.Order.jobTypeDescription == 'Frame to Come') ? _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top"
  }, [_vm._m(1)]) : (_vm.Order.jobTypeDescription == 'Uncut') ? _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('p', [_vm._v("\n                            For this order, there is no need to send anything to the lab. Your uncut lens will be mailed to the address below once completed\n                        ")])]) : _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('p', [_vm._v("\n                            For this order, there is no need to send anything to the lab. Keep your sample frame and the complete pair of glasses will be mailed to the address below once completed.\n                        ")])]), _vm._v(" "), (_vm.Order.jobTypeDescription != 'Frame to Come') ? _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "row no-gutters"
  }, [(_vm.Order.orderLab) ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center box-div"
  }, [_c('span', [_vm._v(_vm._s(_vm.Order.orderLab.name))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.Order.orderLab.shippingStreet))]), _vm._v(" "), (_vm.Order.jobTypeDescription == 'Frame to Come') ? _c('span', [_c('br'), _vm._v(_vm._s("ATTN: Frame-to-Come"))]) : _vm._e(), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.Order.orderLab.shippingCity) + ", " + _vm._s(_vm.Order.orderLab.shippingStateCode) + " " + _vm._s(_vm.Order.orderLab.shippingPostalCode))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Phone: " + _vm._s("(866) 385-0447"))])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.Order.jobTypeDescription == 'Frame to Come') ? _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "row no-gutters",
    staticStyle: {
      "background-color": "yellow"
    }
  }, [(_vm.Order.orderLab) ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center box-div"
  }, [_c('span', [_vm._v(_vm._s(_vm.Order.orderLab.name))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.Order.orderLab.shippingStreet))]), _vm._v(" "), (_vm.Order.jobTypeDescription == 'Frame to Come') ? _c('span', [_c('br'), _vm._v(_vm._s("ATTN: Frame-to-Come"))]) : _vm._e(), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.Order.orderLab.shippingCity) + ", " + _vm._s(_vm.Order.orderLab.shippingStateCode) + " " + _vm._s(_vm.Order.orderLab.shippingPostalCode))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Phone: " + _vm._s("(866) 385-0447"))])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "form-group no-margin-bottom"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Participant Name:")]), _vm._v(" "), (_vm.Account.accountType == 1) ? _c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Account.primaryContact.firstName) + " " + _vm._s(_vm.Account.primaryContact.lastName) + " " + _vm._s(_vm.Account.primaryContact.suffix))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Account.primaryContact.legalName))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group no-margin-bottom"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Email:")]), _vm._v(" "), _c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Account.emailAddress))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group no-margin-bottom"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Phone:")]), _vm._v(" "), _c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm._f("phone_format")(_vm.Account.primaryContact.phoneNumber)))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group no-margin-bottom"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('span', [_vm._v(_vm._s(_vm.Order.shippingFullName))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.shippingAddressLineOne))]), _vm._v(" "), (_vm.shippingAddressLineTwo = null) ? _c('span', [_c('br'), _vm._v(_vm._s(_vm.shippingAddressLineTwo))]) : _vm._e(), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.shippingCity) + ", " + _vm._s(_vm.shippingState) + " " + _vm._s(_vm.shippingPostalCode))]), _c('br'), _vm._v(" "), _c('br')])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group no-margin-bottom"
  }, [_c('vue-barcode', {
    attrs: {
      "value": _vm.Order.orderNumber,
      "options": {
        displayValue: false
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group no-margin-bottom"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Patient:")]), _vm._v(" "), _c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.patFirstName) + " " + _vm._s(_vm.Order.patLastName))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("E-Order #:")]), _vm._v(" "), _c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.orderNumber))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group no-margin-bottom"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Order Reference/PO:")]), _vm._v(" "), _c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.referenceNoPo))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group no-margin-bottom"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Submitted:")]), _vm._v(" "), _c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.FormatDateToLocal(_vm.Order.dateSubmitted)))])])])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_vm._m(5), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Right")]), _vm._v(" "), _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.reSph))]), _vm._v(" "), _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.reCyl))]), _vm._v(" "), _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.reAxis))]), _vm._v(" "), _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.reAdd))]), _vm._v(" "), _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.reSegHeight))]), _vm._v(" "), (!_vm.Order.isOnly1DistancePD) ? _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.reDistPD))]) : _c('td', {
    staticClass: "order-confimation-description",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v(_vm._s(_vm.Order.distancePD))])]), _vm._v(" "), (!_vm.Order.isOnly1NearPD) ? _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.reNearPD))]) : _c('td', {
    staticClass: "order-confimation-description",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v(_vm._s(_vm.Order.nearPD))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Left")]), _vm._v(" "), _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.leSph))]), _vm._v(" "), _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.leCyl))]), _vm._v(" "), _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.leAxis))]), _vm._v(" "), _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.leAdd))]), _vm._v(" "), _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.leSegHeight))]), _vm._v(" "), (!_vm.Order.isOnly1DistancePD) ? _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.leDistPD))]) : _vm._e(), _vm._v(" "), (!_vm.Order.isOnly1NearPD) ? _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.leNearPD))]) : _vm._e()])]), _vm._v(" "), (_vm.Order.IncludeAdditionalRxFields) ? _c('thead', [_vm._m(6)]) : _vm._e(), _vm._v(" "), (_vm.Order.IncludeAdditionalRxFields) ? _c('tbody', [_c('tr', [_c('td', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Right")]), _vm._v(" "), _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.reHorizontalPrismValue))]), _vm._v(" "), _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.reHorizontalPrismDirection))]), _vm._v(" "), _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.reVerticalPrismValue))]), _vm._v(" "), _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.reVerticalPrismDirection))]), _vm._v(" "), _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.reocHeight))]), _vm._v(" "), _c('td', {
    staticClass: "order-confimation-description"
  }), _vm._v(" "), _c('td', {
    staticClass: "order-confimation-description"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Left")]), _vm._v(" "), _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.leHorizontalPrismValue))]), _vm._v(" "), _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.leHorizontalPrismDirection))]), _vm._v(" "), _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.leVerticalPrismValue))]), _vm._v(" "), _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.leVerticalPrismDirection))]), _vm._v(" "), _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.leocHeight))]), _vm._v(" "), _c('td', {
    staticClass: "order-confimation-description"
  }), _vm._v(" "), _c('td', {
    staticClass: "order-confimation-description"
  })])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 center"
  }, [_c('div', {
    staticClass: "row no-gutters"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9 border-box"
  }, [_c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.lensTypeDescription))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 center"
  }, [_c('div', {
    staticClass: "row no-gutters"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9 border-box"
  }, [_c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.lensDesignDescription))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 center"
  }, [_c('div', {
    staticClass: "row no-gutters"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9 border-box"
  }, [_c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.jobTypeDescription))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 center"
  }, [_c('div', {
    staticClass: "row no-gutters"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9 border-box"
  }, [_c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.lensMaterialDescription))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center div-spacing-top"
  }, [_c('div', {
    staticClass: "row no-gutters"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9 border-box"
  }, _vm._l((_vm.Order.lensTreatmentDescription), function(lt) {
    return _c('span', {
      staticClass: "order-confimation-description"
    }, [_vm._v(_vm._s(lt) + ",")])
  }), 0)])]), _vm._v(" "), (_vm.Order.isSpecialOrderNecessary) ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center div-spacing-top"
  }, [_c('div', {
    staticClass: "row no-gutters"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9 border-box"
  }, [_c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.specialInstructions1))])])])]) : _vm._e(), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 center div-spacing-top"
  }, [_c('div', {
    staticClass: "row no-gutters"
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9 border-box"
  }, [_c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.frameManufacturer))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 center div-spacing-top"
  }, [_c('div', {
    staticClass: "row no-gutters"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9 border-box"
  }, [_c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.frameTypeDescription))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 center"
  }, [_c('div', {
    staticClass: "row no-gutters"
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9 border-box"
  }, [_c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.frameBrand))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 center"
  }, [_c('div', {
    staticClass: "row no-gutters"
  }, [_vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9 border-box"
  }, [_c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.frameColor))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 center"
  }, [_c('div', {
    staticClass: "row no-gutters"
  }, [_vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9 border-box"
  }, [_c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.frameModel))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 center"
  }, [_c('div', {
    staticClass: "row no-gutters"
  }, [_vm._m(19), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 border-box"
  }, [_c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.frameEyeSize))])]), _vm._v(" "), _vm._m(20), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 border-box"
  }, [_c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.frameTempleLength))])])])]), _vm._v(" "), _vm._m(21), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "row no-gutters"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 border-box min-height-dispenser-notes"
  }, [_c('span', [_vm._v(_vm._s(_vm.Order.dispenserNotes))])])])])])]) : _vm._e(), _vm._v(" "), (!_vm.isOrderValid) ? _c('div', {
    staticClass: "col-lg-8 offset-lg-2"
  }, [_vm._m(22)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isModalShown) ? _c('jotform-modal', {
    attrs: {
      "Account": _vm.Account,
      "formID": 221084120731038
    },
    on: {
      "closeJotForm": _vm.ToggleJotForm
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.markDispenseModal),
      expression: "markDispenseModal"
    }]
  }, [_c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content g-mt-170"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "my-account-title"
  }, [_vm._v("Mark as Dispensed")]), _vm._v(" "), _c('div', {
    staticClass: "row g-my-20 g-mx-20 "
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 g-my-15"
  }, [_c('label', [_vm._v("Enter Dispense Date:")]), _vm._v(" "), _c('datepicker', {
    attrs: {
      "disabled-picker": _vm.isDataLoading,
      "bootstrap-styling": true,
      "format": _vm.format,
      "name": "uniquename",
      "calendar-button": true,
      "calendar-button-icon": "fa fa-calendar"
    },
    model: {
      value: (_vm.dateDispense),
      callback: function($$v) {
        _vm.dateDispense = $$v
      },
      expression: "dateDispense"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-info--hover g-rounded-10 g-btn-130 g-mx-10 g-font-size-15",
    on: {
      "click": function($event) {
        return _vm.SaveMarkForDispense(_vm.Order.id)
      }
    }
  }, [_vm._v("Mark Dispensed")]), _vm._v(" "), _vm._m(23), _vm._v(" "), _c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-mx-10 g-font-size-15",
    on: {
      "click": function($event) {
        _vm.markDispenseModal = false;
      }
    }
  }, [_vm._v("Cancel")])])])])])])])])]), _vm._v(" "), (_vm.isDataLoading) ? _c('div', {
    staticClass: "row margin-top"
  }, [_c('page-loader')], 1) : _vm._e()], 1), _vm._v(" "), (_vm.isServicePaymentShown) ? _c('service-payment', {
    attrs: {
      "Account": _vm.Account,
      "Order": _vm.Order
    },
    on: {
      "close": function($event) {
        _vm.isServicePaymentShown = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('footer-component')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "order-title"
  }, [_vm._v("\n                            Lab Information\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n                            Please send your frame along with the lab copy of the Order Summary to this lab as soon as possible. If the frame has not been received within 2 weeks, the order will be cancelled.\n                            "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("Please pay careful attention to the lab address. Frames shipped to the wrong lab will be drastically delayed or lost.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "order-title"
  }, [_vm._v("\n                          Participant and Order Information\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Shipping Address:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "order-title"
  }, [_vm._v("\n                            Lens and Prescription Information\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "order-confimation-label order-bg-blue"
  }), _vm._v(" "), _c('th', {
    staticClass: "order-confimation-label order-bg-blue"
  }, [_vm._v("Sphere")]), _vm._v(" "), _c('th', {
    staticClass: "order-confimation-label order-bg-blue"
  }, [_vm._v("Cylinder")]), _vm._v(" "), _c('th', {
    staticClass: "order-confimation-label order-bg-blue"
  }, [_vm._v("Axis")]), _vm._v(" "), _c('th', {
    staticClass: "order-confimation-label order-bg-blue"
  }, [_vm._v("Addition")]), _vm._v(" "), _c('th', {
    staticClass: "order-confimation-label order-bg-blue"
  }, [_vm._v("Seg. Height")]), _vm._v(" "), _c('th', {
    staticClass: "order-confimation-label order-bg-blue"
  }, [_vm._v("Dist. PD")]), _vm._v(" "), _c('th', {
    staticClass: "order-confimation-label order-bg-blue"
  }, [_vm._v("Near PD")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "order-confimation-label order-bg-blue"
  }), _vm._v(" "), _c('th', {
    staticClass: "order-confimation-label order-bg-blue"
  }, [_vm._v("Horizontal Prism")]), _vm._v(" "), _c('th', {
    staticClass: "order-confimation-label order-bg-blue"
  }, [_vm._v("Base")]), _vm._v(" "), _c('th', {
    staticClass: "order-confimation-label order-bg-blue"
  }, [_vm._v("Vertical Prism")]), _vm._v(" "), _c('th', {
    staticClass: "order-confimation-label order-bg-blue"
  }, [_vm._v("Base")]), _vm._v(" "), _c('th', {
    staticClass: "order-confimation-label order-bg-blue"
  }, [_vm._v("OC Height")]), _vm._v(" "), _c('th', {
    staticClass: "order-confimation-label order-bg-blue"
  }), _vm._v(" "), _c('th', {
    staticClass: "order-confimation-label order-bg-blue"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 order-bg-blue border-box"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Lens Type")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 order-bg-blue border-box"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Lens Design")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 order-bg-blue border-box"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Order Type")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 order-bg-blue border-box"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Lens Material")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 order-bg-blue border-box"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Treatment(s)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 order-bg-blue border-box"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Special Instructions")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "order-title"
  }, [_vm._v("\n                            Frame Information\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 order-bg-blue border-box"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Manufacturer")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 order-bg-blue border-box"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Frame Type")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 order-bg-blue border-box"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Brand")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 order-bg-blue border-box"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Color")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 order-bg-blue border-box"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Name/Model")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 order-bg-blue border-box"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Eye Size")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 order-bg-blue border-box"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Temple")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "order-title"
  }, [_vm._v("\n                            Patient/Order Notes\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('p', {
    staticClass: "error-message"
  }, [_vm._v("Error!")]), _vm._v(" "), _c('p', {
    staticClass: "order-confimation-description"
  }, [_vm._v("\n                            Order requested is not valid.\n                        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('small', [_vm._v("This will mark this order as dispensed. This cannot be undone in bulk, but individual orders can be marked as Not Dispensed on the Order Confirmation page.")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c124d340", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c124d340"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/Order/OrderConfirmation.vue
// module id = 545
// module chunks = 3